
import React from 'react';
import { useCompanyData } from '@/hooks/useCompanyData';
import ShareCompanyProfileLink from './links/ShareCompanyProfileLink';

const CompanyLinksTab: React.FC = () => {
  const { companyData } = useCompanyData();
  
  return (
    <div>
      <p className="text-gray-600 mb-6">Manage links to your company's website, social media, and other external resources.</p>
      
      {companyData && companyData.name && (
        <ShareCompanyProfileLink companyName={companyData.name} />
      )}
    </div>
  );
};

export default CompanyLinksTab;
